/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getContextKindByProjectKeyAndKeyOverrides';

export type GetContextKindByProjectKeyAndKeyPathParams = NonNullable<
  operations['getContextKindByProjectKeyAndKey']['parameters']['path']
>;

export type GetContextKindByProjectKeyAndKeyQueryParams = NonNullable<
  operations['getContextKindByProjectKeyAndKey']['parameters']['query']
>;

export interface Input extends GetContextKindByProjectKeyAndKeyPathParams {
  apiVersion?: string;
  query?: GetContextKindByProjectKeyAndKeyQueryParams;
}

export async function getContextKindByProjectKeyAndKey(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/context-kinds/{key}', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
